var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    _vm._b(
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isDisplay,
            expression: "isDisplay"
          }
        ],
        staticClass: "preview-form-grid",
        style: { "padding-left": _vm.paddingLeft },
        attrs: { type: "flex" }
      },
      "el-row",
      {
        gutter: _vm.gridGutter,
        justify: _vm.gridJustify,
        align: _vm.gridAlign
      },
      false
    ),
    [
      _vm.isDisplay
        ? _vm._l(_vm.formNode.children, function(col) {
            return _c(
              "el-col",
              {
                key: col.id,
                attrs: {
                  span: _vm.formMap[col.id].baseOption.span
                    ? _vm.formMap[col.id].baseOption.span
                    : 0
                }
              },
              _vm._l(col.children, function(el) {
                return _c("preview-item-template", {
                  key: el.id,
                  attrs: { formNode: el, parent: col.children }
                })
              }),
              1
            )
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33dd17ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33dd17ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preview_item/PreviewItemGrid.vue
// module id = null
// module chunks = 